<template>
  <el-popover
    placement="right"
    title=""
    trigger="hover">
    <img slot="reference" :src="imgSrc" :style="{width: defaultWidth+'px',height:defaultHeight+'px'}" class="">
    <img :src="imgSrc" :style="{width: defaultWidth*3+'px',height:'100%' }" />
  </el-popover>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    props: {
      imgSrc: {},
      defaultWidth: {
        default: 250
      },
      defaultHeight: {
        default: 150
      },
      // afterWidth: {
      //   default: 500
      // },
      // afterHeight: {
      //   default: 300
      // }
    },
    data () {
      return {}
    },
    computed: {
      ...mapState({})
    }
  }
</script>

<style scoped>

</style>
